import { type APIComponentAttributes, type ArdoqId } from '@ardoq/api-types';

export const getParentComponent = (
  component: APIComponentAttributes,
  componentsById: Record<ArdoqId, APIComponentAttributes>
): APIComponentAttributes | null =>
  component.parent ? (componentsById[component.parent] ?? null) : null;
